import { giphyBlack } from '@giphy/colors'
import { SegmentedControl } from 'ui'
import CreationToolGradient from '../../../types/gradient'
import CreationToolRating from '../../../types/rating'
import CreationToolUploadField from '../../../types/upload-field'
import CollapsibleField from './field-collapsible'
import Instructions from './field-instructions'

type Props = {
    className?: string
    field: CreationToolUploadField
    defaultRating?: CreationToolRating
    gradient?: CreationToolGradient
    showInstructions?: boolean
    onChange: (rating: CreationToolRating) => void
}

const CreationRatingField = ({
    className,
    field,
    defaultRating = CreationToolRating.Unrated,
    showInstructions = false,
    onChange,
}: Props) => {
    const ratings = CreationToolRating.all()
    const gradient = CreationToolRating.gradient(defaultRating)
    const color = gradient ? undefined : '#fff'
    const titles = ratings.map(CreationToolRating.title)
    const defaultIndex = ratings.indexOf(defaultRating)

    function onIndexChange(index: number) {
        onChange(ratings[index])
    }

    return (
        <CollapsibleField className={className} field={field}>
            <SegmentedControl
                backgroundColor={giphyBlack}
                color={color}
                index={defaultIndex}
                gradient={gradient}
                options={titles}
                size="medium"
                onChange={onIndexChange}
            />
            {showInstructions && <Instructions field={field} />}
        </CollapsibleField>
    )
}

export default CreationRatingField
